import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  onScrollToOffer: () => void;
}
export function HeroSection({
  onScrollToOffer
}: HeroSectionProps) {
  return <section className="pt-32 pb-16 px-4 md:pt-40 md:pb-24 relative overflow-hidden" data-id="element-60">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-[#00B4D8]/20 blur-[120px] rounded-full pointer-events-none" data-id="element-61" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-63">
          <p className="text-[#00B4D8] font-semibold tracking-wide uppercase text-sm md:text-base mb-6" data-id="element-64">
            Para emprendedores digitales que ya venden infoproductos y quieren
            escalar sin contratar un equipo de 10 personas.
          </p>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-65">
            33 Asistentes de IA que crean, venden y escalan tu infoproducto por
            vos.
          </h1>

          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-66">
            InfoSkills Pro es un kit de 33 skills de inteligencia artificial
            diseñadas específicamente para el negocio de infoproductos. Desde
            validar tu nicho hasta analizar las métricas de tu campaña — cada
            skill es un especialista que trabaja para vos dentro de Claude.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mb-12 relative" data-id="element-67">
          <img src="https://cdn.magicpatterns.com/uploads/ntUnWSfY4rpG3Xr7ommpfs/Paquete_completo_Infoskills_Pro_con_bonos_(1).png" alt="InfoSkills Pro Pack Completo" className="w-full max-w-4xl mx-auto drop-shadow-2xl cursor-pointer hover:scale-[1.02] transition-transform duration-300 rounded-2xl" onClick={onScrollToOffer} data-id="element-68" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-69">
          <button onClick={onScrollToOffer} className="bg-[#27AE60] hover:bg-[#219653] text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(39,174,96,0.4)] hover:shadow-[0_0_40px_rgba(39,174,96,0.6)] transition-all flex items-center gap-3 transform hover:-translate-y-1 w-full md:w-auto justify-center" data-id="element-70">
            Quiero mis 33 Skills de IA <ArrowRight className="w-6 h-6" data-id="element-71" />
          </button>
          <p className="text-gray-400 mt-4 text-sm flex items-center gap-2" data-id="element-72">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-73"></span>
            Acceso inmediato. Descarga al instante.
          </p>
        </motion.div>
      </div>
    </section>;
}